import { useId } from 'react'
import { site } from '@/config/site'
import { Picture } from '@/components/ui/Picture'

/**
 * Donate band — full-bleed candid photo, dark overlay, big statement. Until
 * the donation platform is live, it shows the mailing address for checks
 * (client request, 28 Sep 2026) instead of an external donate button.
 */
export function Donate() {
  const headingId = useId()
  return (
    <section
      id="donate"
      aria-labelledby={headingId}
      className="relative isolate overflow-hidden bg-ink-deep text-surface"
    >
      <div aria-hidden className="absolute inset-0">
        <Picture
          name="donate-band"
          sizes="100vw"
          alt=""
          className="h-full w-full object-cover opacity-55"
        />
      </div>
      <div
        aria-hidden
        className="absolute inset-0 bg-gradient-to-r from-ink-deep via-ink-deep/85 to-ink-deep/55"
      />

      <div className="relative mx-auto max-w-[88rem] px-6 py-24 sm:px-10 sm:py-28">
        <div className="max-w-3xl">
          <h2
            id={headingId}
            className="max-w-[18ch] font-display text-display-1 font-extrabold leading-[1.02] text-surface"
          >
            Make a donation.
          </h2>
          <p className="measure mt-8 text-lg leading-relaxed text-surface/85 sm:text-xl">
            Your contribution funds the cross-sector work no single
            government, company or community will fund alone. Tax-deductible
            in the U.S. as a 501(c)(3) nonprofit.
          </p>
          <div className="mt-10 border-l-4 border-brand pl-6">
            <p className="text-sm font-bold uppercase tracking-[0.12em] text-surface/75">
              To make a donation, please mail checks to:
            </p>
            <address className="mt-3 font-display text-2xl font-bold not-italic leading-snug text-surface sm:text-3xl">
              {site.donationMailingAddress.map((line) => (
                <span key={line} className="block">
                  {line}
                </span>
              ))}
            </address>
          </div>
        </div>
      </div>
    </section>
  )
}
